export enum HighlightEffect {
  ButtonHexOutline = 'highlight-button-hex-outline',
  ButtonVideoPlayer = 'highlight-button-video-player',
  ButtonModule = 'highlight-button-module',
  InputOutline = 'highlight-input-outline',
  LinkUnderline = 'highlight-link-underline',
  TextTermsOutline = 'highlight-text-terms-outline',
  Iframe = 'highlight-iframe'
}
